import Footer from "../footer/Footer";
import Navbar from "../navbar/TopNavbar";
import React, { useEffect } from "react";
import cr1 from "../../assets/banner/righttosafety.jpg";
import cr2 from "../../assets/banner/righttochose.jpg";
import cr3 from "../../assets/banner/righttobeinformed.jpg";
import cr4 from "../../assets/banner/righttoeducation.jpg";
import cr5 from "../../assets/banner/righttobeheard.jpg";
import cr6 from "../../assets/banner/Sseekredressal.jpg";
import "../../components/style.css";
import {Helmet} from "react-helmet";

const AboutConsumer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
   <Helmet>
    <title>About CRO | Consumer Right Origination</title> 
    <meta name="description" content="Learn about the origin and history of consumer rights. Explore laws, tips, and resources to protect your rights and resolve complaints effectively." />
    
    {/* <!-- Open Graph Metadata --> */}
    <meta property="og:title" content="About CRO | Consumer Right Origination" />
    <meta property="og:description" content="Discover the history of consumer rights and gain insights into how you can safeguard your rights as a consumer." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://example.com/consumer-right-origination" />
    <meta property="og:image" content="https://example.com/images/consumer-rights.jpg" />
    <meta property="og:locale" content="en_US" />
    
    {/* <!-- Twitter Metadata --> */}
    <meta name="x:card" content="summary_large_image" />
    <meta name="x:title" content="About CRO | Consumer Rights Origination" />
    <meta name="x:description" content="Empowering Consumers, Enforcing Rights. CRO - Consumer Rights Organization | Voluntary organization working PAN India.  Links, Repost not endorsements." />
    <meta name="x:image" content="https://x.com/thecroindia?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" />

    <meta property="og:image:alt" content="https://www.linkedin.com/company/consumer-rights-organisation/?originalSubdomain=in" />

    {/* <!-- Additional Metadata --> */}
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta charset="UTF-8" />
    <meta http-equiv="content-language" content="en" />
</Helmet>
      <Navbar />
      <br></br>
      <div className="container mt-5 pt-5">
        <h4 className="text-center fw-bolder mt-5">
          BASIC CONSUMER RIGHTS EVERYONE MUST KNOW
        </h4>
        <div className="row mt-5 d-flex align-items-start ">
          <div className="col-md-5 m-0 p-0 image-con">
            <img src={cr1} alt="" />
          </div>
          <div className="col-md-7">
            <h5 className="fw-bolder mb-4">RIGHT TO SAFETY </h5>
            <p style={{ lineHeight: 2, fontSize: "1rem" }}>
              Means right to be protected against the marketing of goods and services, which are hazardous to life and property. The purchased goods and services availed of should not only meet their immediate needs, but also fulfil long term interests.
              Before purchasing, consumers should insist on the quality of the products as well as on the guarantee of the products and services. They should preferably purchase quality marked products such as ISI,AGMARK, etc.
            </p>
          </div>
        </div>
        <div className="row mt-5 d-flex align-items-start ">
          <div className="col-md-5 image-con m-0 p-0">
            <img src={cr2} alt="" />
          </div>
          <div className="col-md-7">
            <h5 className="fw-bolder mb-4">RIGHT TO CHOOSE </h5>
            <p style={{ lineHeight: 2, fontSize: "1rem" }}>
              Means right to be assured, wherever possible of access to variety of goods and services at competitive price. In case of monopolies, it means right to be assured of satisfactory quality and service at a fair price. It also includes right to basic goods and services. This is because unrestricted right of the minority to choose can mean a denial for the majority of its fair share. This right can be better exercised in a competitive market where a variety of goods are available at competitive prices.
            </p>
          </div>
        </div>
        <div className="row mt-5 d-flex align-items-start ">
          <div className="col-md-5 image-con m-0 p-0">
            <img src={cr3} alt="" />
          </div>
          <div className="col-md-7">
            <h5 className="fw-bolder mb-4">RIGHT TO BE INFORMED </h5>
            <p style={{ lineHeight: 2, fontSize: "1rem" }}>
              Means right to be informed about the quality, quantity, potency, purity, standard and price of goods so as to protect the consumer against unfair trade practices.
              Consumer should insist on getting all the information about the product or service before making a choice or a decision. This will enable him to act wisely and responsibly and also enable him to desist from falling prey to high pressure selling techniques.
            </p>
          </div>
        </div>

        <div className="row mt-5 d-flex align-items-start ">
          <div className="col-md-5 image-con m-0 p-0">
            <img src={cr4} alt="" />
          </div>
          <div className="col-md-7">
            <h5 className="fw-bolder mb-2">RIGHT TO CONSUMER EDUCATION </h5>
            <p className="mb-2" style={{ lineHeight: 1.5, fontSize: "1rem" }}>
              Means the right to acquire the knowledge and skill to be an informed consumer throughout life.Ignorance of consumers, particularly of rural consumers, is mainly responsible for their exploitation. They should know their rights and must exercise them. Only then real consumer protection can be achieved with success.
            </p>
          </div>
        </div>
        <div className="row mt-5 d-flex align-items-start ">
          <div className="col-md-5 image-con m-0 p-0">
            <img src={cr5} alt="" />
          </div>
          <div className="col-md-7">
            <h5 className="fw-bolder mb-4">RIGHT TO BE HEARD </h5>
            <p style={{ lineHeight: 2, fontSize: "1rem" }}>
              Means that consumer's interests will receive due consideration at appropriate forums. It also includes right to be represented in various forums formed to consider the consumer's welfare.
              The Consumers should form non-political and non-commercial consumer organizations which can be given representation in various committees formed by the Government and other bodies in matters relating to consumers.
            </p>
          </div>
        </div>
        <div className="row mt-5 d-flex align-items-start ">
          <div className="col-md-5 image-con m-0 p-0">
            <img src={cr6} alt="" />
          </div>
          <div className="col-md-7 ">
            <h5 className="fw-bolder mb-4">RIGHT TO SEEK REDRESSAL </h5>
            <p style={{ lineHeight: 2, fontSize: "1rem" }}>
              Means right to seek redressal against unfair trade practices or unscrupulous exploitation of consumers. It also includes right to fair settlement of the genuine grievances of the consumer.
              Consumers must make complaint for their genuine grievances.Many a times their complaint may be of small value but its impact on the society as a whole may be very large. They can also take the help of consumer organisations in seeking redressal of their grievances.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutConsumer;
